import React, { forwardRef } from 'react';

import {
    Button, Dialog, DialogActions,
    DialogContent, DialogTitle, Slide, Alert
} from '@mui/material';
import { useSelector } from 'react-redux';
import useCustomAlert from '../hooks/useCustomAlert';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="right" ref={ref} {...props} />;
});

export default function CustomAlert() {

    const alert = useSelector(state => state.alert);
    const customAlert = useCustomAlert();

    const handleClose = () => {
        customAlert.hide();
    };

    const onAgree = () => {
        if(alert.onClose) {
            alert.onClose();
        }
        customAlert.hide();
    }

    return (
        <Dialog
            open={alert.show}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle sx={{ textTransform: 'capitalize' }} >{alert.severity}</DialogTitle>
            <DialogContent>
                <Alert severity={alert.severity || 'info'} >{alert.message}</Alert>
            </DialogContent>
            <DialogActions>
                <Button size='small' variant='outlined' onClick={handleClose}>Cancel</Button>
                <Button size='small' variant='contained' color={alert.severity || 'primary'} 
                    onClick={onAgree}
                >Ok</Button>
            </DialogActions>
        </Dialog>
    );
}